type GridSettings = {
    gutter: string;
    debug: boolean;
};

type ColorsSettings = {
    main: string;
    inverted: string;
    accent: string;
    accentLight: string;

    grayLight: string;
    grayMedium: string;
    grayHeavy: string;
    aarpOutline: string;
    aarpUnderline: string;
};

type SizeSettings = {
    xss: string;
    xs: string;
    sm: string;
    md: string;
    lg: string;
    xl: string;
    xxl: string;
    x3l?: string;
    x4l?: string;
    h1?: string;
    h2?: string;
    h3?: string;
};

type BreakPointsSettings = {
    phone: number;
    mobile: number;
    desktop: number;
};

export type Theme = {
    grid: GridSettings;
    colors: ColorsSettings;
    text: SizeSettings;
    spacing: SizeSettings;
    breakPoints: BreakPointsSettings;
};

const ThemeSettings: Theme = {
    grid: {
        gutter: '0.75em',
        debug: false,
    },

    colors: {
        main: '#333',
        inverted: '#fff',
        accent: '#2b779b',
        accentLight: '#62727b',
        grayLight: '#f6f7f8',
        grayMedium: '#e9eaeb',
        grayHeavy: '#d1d2d3',
        aarpOutline: '#ef382a',
        aarpUnderline: '#bd1b0e',
    },

    breakPoints: {
        phone: 480,
        mobile: 991,
        desktop: 992,
    },

    spacing: ((): SizeSettings => {
        const unit = 1;

        return {
            xss: `${0.25 * unit}em`, // 4
            xs: `${0.8 * unit}em`,   // 8
            sm: `${0.9375 * unit}em`, // 15
            md: `${unit}em`,         // 16
            lg: `${1.25 * unit}em`,  // 20
            xl: `${1.875 * unit}em`, // 30
            xxl: `${2.5 * unit}em`,  // 40
            x3l: `${3.75 * unit}em`, // 60
            x4l: `${5 * unit}em`,    // 80
        };
    })(),

    text: ((): SizeSettings => {
        const unit = 1;

        return {
            xss: `${0.5 * unit}em`,   // 8
            xs: `${0.9375 * unit}em`, // 15
            sm: `${unit}em`,          // 16
            md: `${1.125 * unit}em`,  // 18
            lg: `${1.1875 * unit}em`, // 19
            xl: `${1.375 * unit}em`,  // 22
            xxl: `${1.5 * unit}em`,   // 24
            h1: `${2.8125 * unit}em`, // 45
            h2: `${2.125 * unit}em`,  // 36
            h3: `${1.875 * unit}em`,  // 30
        };
    })(),
};

export default ThemeSettings;
